import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {chain}                          from "@Common/utils/fs";

export const setCartPayments = async (cart, {cards, apis}) => {
    const cartId = cart.cartId;
    if (cards?.length) {
        await apis.next.cart.updateCart(chain(
            {cartId},
            (_) => setNestedValue(_, ["removePayments", "creditCards"], getNestedValue(cart, ["appliedPayments", "creditCards"])),
            (_) => setNestedValue(_, ["payments", "creditCards"], cards.map((cc) => {
                if (!cc.cardToken) {
                    return {
                        ...cc,
                        "type": "nonce",
                        // amount: remainingAmount,
                    };
                } else {
                    return {
                        "type": "token",
                        "cardToken" : cc.cardToken,
                        "cardHolderName": cc.cardHolderName,
                        cardLast4: cc.cardLast4,
                        amount: cc.amount,
                    };
                }
            })),
        ));
    } else if (cart.appliedPayments?.creditCards?.length) {
        await apis.next.cart.updateCart(chain(
            {cartId},
            (_) => setNestedValue(_, ["removePayments", "creditCards"], getNestedValue(cart, ["appliedPayments", "creditCards"])),
        ));
    }
};
